export default __webpack_public_path__ + "static/media/responsive.dd672032.png";